// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reportHistoryNavbar ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
}

.Balance .css-i4bv87-MuiSvgIcon-root {
  margin-bottom: -8px;
  margin-right: -5px;
}
.css-az8st9-MuiDataGrid-root{
  border: none !important;
  background-color: #282B30 !important;
  color: #eee !important;
}

.css-az8st9-MuiDataGrid-root{
  border: none !important;
}

.reportHistoryNavbar ul li {
  list-style: none;
  text-align: center;
  padding: 12px 0;
  cursor: pointer;
  flex: 1 1;
  margin: 0;
}
.MuiDialogTitle-root + .css-ypiqx9-MuiDialogContent-root {
  min-width: 350px !important;
}
.datePicker {
  background-color: #282b30;
  padding: 7px 20px;
}
.css-ptkaw2-MuiDataGrid-root {
  color: #fff !important;
}
.dateDropdown {
  background-color: #111214;
  width: 250px;
  position: absolute;
  display: inline-flex;
  z-index: 9;
  height: 135px;
  padding: 10px;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;
}

.datagrid-container {
  width: 100% !important;
}
.bottom-container{
  justify-content: flex-end;
  display: flex;
}
.datagrid-container table {
  color: white;
}

.reportHistoryContent {
  margin-top: 15px;
}

.reportsHistory .css-5wly58-MuiDataGrid-root {
  color: white !important;
  background-color: #282b30;
  border: none !important;
  padding: 10px 20px;
  border-radius: 0 !important;
  min-height: 330px !important;
}

.reportsHistory .css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root {
  color: white !important;
}

.reportsHistory .MuiDataGrid-cell {
  width: 100px !important;
}
.reportsHistory .css-s1v7zr-MuiDataGrid-virtualScrollerRenderZone {
  width: 100% !important;
}
.reportsHistory .css-5wly58-MuiDataGrid-root .MuiDataGrid-row {
  width: 100% !important;
  cursor: pointer;
}

.reportsHistory .css-5wly58-MuiDataGrid-root .MuiDataGrid-withBorderColor {
  border: none !important;
}

.reportsHistory .css-rtrcn9-MuiTablePagination-root {
  color: white !important;
  margin-right: 55px;

  text-align: right !important;
  right: 0 !important;
  float: right !important;
  position: absolute;
}

.reportsHistory .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon {
  color: white !important;
}
.reportsHistory .css-gl260s-MuiDataGrid-columnHeadersInner {
  background-color: #1e2024;
  width: fit-content !important;
}
.reportsHistory .MuiDataGrid-cell {
  border-left: 1px solid #1e2024 !important;
}

.css-1miuj5f-MuiDataGrid-panelWrapper {
  background-color: #282b30 !important;
  border-radius: 0 !important;
}
.css-154sxbz-MuiPaper-root-MuiDataGrid-paperP {
  border-radius: 0 !important;
}
.css-1ps6pg7-MuiPaper-root {
  background-color: #282b30 !important;
  border-radius: 0 !important;
  color: #eee !important;
}

.css-ptiqhd-MuiSvgIcon-root {
  color: #eee;
}
.css-1x51dt5-MuiInputBase-input-MuiInput-input {
  color: #eee !important;
}

.css-m5hdmq-MuiInputBase-root-MuiInput-root-MuiSelect-root {
  color: #eee !important;
}
.css-1dmqq7i-MuiNativeSelect-select-MuiInputBase-input-MuiInput-input:not(
    [multiple]
  )
  option {
  background-color: #282b30 !important;
}
.MuiDataGrid-columnHeader {
  width: 20% !important;
}
.css-yrdy0g-MuiDataGrid-columnHeaderRow {
  width: 100% !important;
}

.css-5wly58-MuiDataGrid-root .MuiDataGrid-columnHeader:focus {
  outline: none !important;
}

.css-5wly58-MuiDataGrid-root .MuiDataGrid-cell:focus {
  outline: none !important;
}

.reportDataGrid .css-axafay-MuiDataGrid-virtualScroller {
  height: fit-content;
  max-height: 200px !important;
  overflow-y: scroll;
}

.totalAmount {
  margin-top: 10px;
  background-color: #282b30;
  padding: 10px;
}

.backButton {
  float: right;
  margin-right: 10px;
  margin-top: 7px;
  background-color: #666666;
  cursor: pointer;
  z-index: 9;
}

.totalAmount table {
  width: 100%;
}
.totalText {
  display: inline;
  float: left;
}

.totalAmount table td {
  border: 1px solid #6b6b6b;
  padding: 10px 5px 10px 15px;
}
.totalAmount table tr td:first-child {
  border: none;

  padding: 10px 1px 10px 15px;
}

.csvImageHolder {
  width: 30px;
  height: 30px;
  border: 1px solid #666666;
  margin-left: 10px;
}

.confirmButton {
  margin-top: 90px;
  float: right;
  text-align: right;
  width: 100%;
  z-index: -2;
  margin-right: 16px;
}

.confirmButton button {
  float: right;
  background-color: #666666;
  color: #dfdddd;
  border-radius: 0 !important;
  font-size: 11px !important;
}

.endDatePicker {
  position: fixed;
  margin-top: 40px;
  z-index: -1;
}

.endDatePicker input {
  background-color: #2e2e2e;
  color: #dfdddd;
  padding: 3px;
}
.showingDate {
  margin-bottom: 10px;
}

.datePicker svg {
  width: 20px;
  margin-bottom: -7px;
  cursor: pointer;
  z-index: 9;
}
.css-rtrcn9-MuiTablePagination-root {
  margin-top: -615px;
}

.reportDataGrid button:disabled {
  background: none !important;
  color: #dfdddd !important;
  border: none !important;
}
.startDatePicker {
  position: fixed;
  margin-bottom: 20px;
}

.fromTo {
  width: 50px !important;
  display: inline-block;
  margin: 0 !important;
}

.startDatePicker input {
  background-color: #2e2e2e;
  color: #dfdddd;
  padding: 3px;
}
.reportsHistory .MuiDataGrid-selectedRowCount {
  display: none !important;
}

.reportsHistory .MuiToolbar-root {
  margin-left: 50px !important;
}

.chart-button button {
  background-color: #dfdddd;
  border-radius: 0;
  width: 25px;
  height: 25px;
  object-fit: fill;
  padding: 0;
  margin: 0;
  border: 1px solid #6b6b6b;
}

.chart-button button image {
  width: 25px;
}

.css-az8st9-MuiDataGrid-root .MuiDataGrid-withBorderColor{
  border: none !important;
}
.css-az8st9-MuiDataGrid-root .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell{
  border: none !important;
}

.css-5wly58-MuiDataGrid-root .MuiDataGrid-cell:focus-within {
  outline: none !important;
}

.totalAmount table tbody tr td:nth-last-child(2) {
  width: 15px;
  border: none !important;
}

.totalAmount .pdfIcon {
  font-size: 30px;
}

.totalAmount table tbody tr td:last-child {
  border: none !important;
}

@media screen and (max-width: 700px) {
  .css-16c50h-MuiInputBase-root-MuiTablePagination-select {
    display: none !important;
  }
  .css-rtrcn9-MuiTablePagination-root .MuiTablePagination-selectLabel {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ReportHistory/reportsHistory.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;EACP,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;;EAElB,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA;;;;EAIE,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,YAAY;;EAEZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".reportHistoryNavbar ul {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n}\n\n.Balance .css-i4bv87-MuiSvgIcon-root {\n  margin-bottom: -8px;\n  margin-right: -5px;\n}\n.css-az8st9-MuiDataGrid-root{\n  border: none !important;\n  background-color: #282B30 !important;\n  color: #eee !important;\n}\n\n.css-az8st9-MuiDataGrid-root{\n  border: none !important;\n}\n\n.reportHistoryNavbar ul li {\n  list-style: none;\n  text-align: center;\n  padding: 12px 0;\n  cursor: pointer;\n  flex: 1;\n  margin: 0;\n}\n.MuiDialogTitle-root + .css-ypiqx9-MuiDialogContent-root {\n  min-width: 350px !important;\n}\n.datePicker {\n  background-color: #282b30;\n  padding: 7px 20px;\n}\n.css-ptkaw2-MuiDataGrid-root {\n  color: #fff !important;\n}\n.dateDropdown {\n  background-color: #111214;\n  width: 250px;\n  position: absolute;\n  display: inline-flex;\n  z-index: 9;\n  height: 135px;\n  padding: 10px;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n}\n\n.datagrid-container {\n  width: 100% !important;\n}\n.bottom-container{\n  justify-content: flex-end;\n  display: flex;\n}\n.datagrid-container table {\n  color: white;\n}\n\n.reportHistoryContent {\n  margin-top: 15px;\n}\n\n.reportsHistory .css-5wly58-MuiDataGrid-root {\n  color: white !important;\n  background-color: #282b30;\n  border: none !important;\n  padding: 10px 20px;\n  border-radius: 0 !important;\n  min-height: 330px !important;\n}\n\n.reportsHistory .css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root {\n  color: white !important;\n}\n\n.reportsHistory .MuiDataGrid-cell {\n  width: 100px !important;\n}\n.reportsHistory .css-s1v7zr-MuiDataGrid-virtualScrollerRenderZone {\n  width: 100% !important;\n}\n.reportsHistory .css-5wly58-MuiDataGrid-root .MuiDataGrid-row {\n  width: 100% !important;\n  cursor: pointer;\n}\n\n.reportsHistory .css-5wly58-MuiDataGrid-root .MuiDataGrid-withBorderColor {\n  border: none !important;\n}\n\n.reportsHistory .css-rtrcn9-MuiTablePagination-root {\n  color: white !important;\n  margin-right: 55px;\n\n  text-align: right !important;\n  right: 0 !important;\n  float: right !important;\n  position: absolute;\n}\n\n.reportsHistory .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon {\n  color: white !important;\n}\n.reportsHistory .css-gl260s-MuiDataGrid-columnHeadersInner {\n  background-color: #1e2024;\n  width: fit-content !important;\n}\n.reportsHistory .MuiDataGrid-cell {\n  border-left: 1px solid #1e2024 !important;\n}\n\n.css-1miuj5f-MuiDataGrid-panelWrapper {\n  background-color: #282b30 !important;\n  border-radius: 0 !important;\n}\n.css-154sxbz-MuiPaper-root-MuiDataGrid-paperP {\n  border-radius: 0 !important;\n}\n.css-1ps6pg7-MuiPaper-root {\n  background-color: #282b30 !important;\n  border-radius: 0 !important;\n  color: #eee !important;\n}\n\n.css-ptiqhd-MuiSvgIcon-root {\n  color: #eee;\n}\n.css-1x51dt5-MuiInputBase-input-MuiInput-input {\n  color: #eee !important;\n}\n\n.css-m5hdmq-MuiInputBase-root-MuiInput-root-MuiSelect-root {\n  color: #eee !important;\n}\n.css-1dmqq7i-MuiNativeSelect-select-MuiInputBase-input-MuiInput-input:not(\n    [multiple]\n  )\n  option {\n  background-color: #282b30 !important;\n}\n.MuiDataGrid-columnHeader {\n  width: 20% !important;\n}\n.css-yrdy0g-MuiDataGrid-columnHeaderRow {\n  width: 100% !important;\n}\n\n.css-5wly58-MuiDataGrid-root .MuiDataGrid-columnHeader:focus {\n  outline: none !important;\n}\n\n.css-5wly58-MuiDataGrid-root .MuiDataGrid-cell:focus {\n  outline: none !important;\n}\n\n.reportDataGrid .css-axafay-MuiDataGrid-virtualScroller {\n  height: fit-content;\n  max-height: 200px !important;\n  overflow-y: scroll;\n}\n\n.totalAmount {\n  margin-top: 10px;\n  background-color: #282b30;\n  padding: 10px;\n}\n\n.backButton {\n  float: right;\n  margin-right: 10px;\n  margin-top: 7px;\n  background-color: #666666;\n  cursor: pointer;\n  z-index: 9;\n}\n\n.totalAmount table {\n  width: 100%;\n}\n.totalText {\n  display: inline;\n  float: left;\n}\n\n.totalAmount table td {\n  border: 1px solid #6b6b6b;\n  padding: 10px 5px 10px 15px;\n}\n.totalAmount table tr td:first-child {\n  border: none;\n\n  padding: 10px 1px 10px 15px;\n}\n\n.csvImageHolder {\n  width: 30px;\n  height: 30px;\n  border: 1px solid #666666;\n  margin-left: 10px;\n}\n\n.confirmButton {\n  margin-top: 90px;\n  float: right;\n  text-align: right;\n  width: 100%;\n  z-index: -2;\n  margin-right: 16px;\n}\n\n.confirmButton button {\n  float: right;\n  background-color: #666666;\n  color: #dfdddd;\n  border-radius: 0 !important;\n  font-size: 11px !important;\n}\n\n.endDatePicker {\n  position: fixed;\n  margin-top: 40px;\n  z-index: -1;\n}\n\n.endDatePicker input {\n  background-color: #2e2e2e;\n  color: #dfdddd;\n  padding: 3px;\n}\n.showingDate {\n  margin-bottom: 10px;\n}\n\n.datePicker svg {\n  width: 20px;\n  margin-bottom: -7px;\n  cursor: pointer;\n  z-index: 9;\n}\n.css-rtrcn9-MuiTablePagination-root {\n  margin-top: -615px;\n}\n\n.reportDataGrid button:disabled {\n  background: none !important;\n  color: #dfdddd !important;\n  border: none !important;\n}\n.startDatePicker {\n  position: fixed;\n  margin-bottom: 20px;\n}\n\n.fromTo {\n  width: 50px !important;\n  display: inline-block;\n  margin: 0 !important;\n}\n\n.startDatePicker input {\n  background-color: #2e2e2e;\n  color: #dfdddd;\n  padding: 3px;\n}\n.reportsHistory .MuiDataGrid-selectedRowCount {\n  display: none !important;\n}\n\n.reportsHistory .MuiToolbar-root {\n  margin-left: 50px !important;\n}\n\n.chart-button button {\n  background-color: #dfdddd;\n  border-radius: 0;\n  width: 25px;\n  height: 25px;\n  object-fit: fill;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #6b6b6b;\n}\n\n.chart-button button image {\n  width: 25px;\n}\n\n.css-az8st9-MuiDataGrid-root .MuiDataGrid-withBorderColor{\n  border: none !important;\n}\n.css-az8st9-MuiDataGrid-root .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell{\n  border: none !important;\n}\n\n.css-5wly58-MuiDataGrid-root .MuiDataGrid-cell:focus-within {\n  outline: none !important;\n}\n\n.totalAmount table tbody tr td:nth-last-child(2) {\n  width: 15px;\n  border: none !important;\n}\n\n.totalAmount .pdfIcon {\n  font-size: 30px;\n}\n\n.totalAmount table tbody tr td:last-child {\n  border: none !important;\n}\n\n@media screen and (max-width: 700px) {\n  .css-16c50h-MuiInputBase-root-MuiTablePagination-select {\n    display: none !important;\n  }\n  .css-rtrcn9-MuiTablePagination-root .MuiTablePagination-selectLabel {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
